import { graphql, useStaticQuery } from 'gatsby';
export const useFeaturedBlogPosts = () => {
    const query = useStaticQuery(graphql `
      query useFeaturedBlogPostsQuery {
        cosmos {
          collections {
            blog_posts(paging: { take: 3 }, sort: [{ field: date, direction: DESC }], where: [{ field: visible, operation: eq, value: "true" }]) {
              title
              body
              preview
              tags {
                name
              }
              main_image {
                ticket
                fileName
              }
              date
              author {
                name
                position
                photo_url {
                  ticket
                  fileName
                }
                alt_photo_url {
                  ticket
                  fileName
                }
                socials {
                  linked_in
                  twitter
                  instagram
                  dribbble
                  github
                }
              }
            }
          }
        }
      }
    `);
    return {
        blogPosts: query.cosmos.collections.blog_posts,
    };
};
export default useFeaturedBlogPosts;
